function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */


import Backbone from '@polleverywhere/backbone';
import PaginatedCollection from './paginated_collection';
import Participant from './participant';
import _ from 'underscore';
import URI from 'urijs';
/**
 * Class representing a collection of Participant models
 */

var Participants = /*#__PURE__*/function (_PaginatedCollection) {
  _inheritsLoose(Participants, _PaginatedCollection);

  function Participants() {
    return _PaginatedCollection.apply(this, arguments) || this;
  }

  var _proto = Participants.prototype;
  /**
   * @constructor
   * Set up the default query params
   */

  _proto.initialize = function initialize() {
    _PaginatedCollection.prototype.initialize.apply(this, arguments);

    this.queryParams = new Backbone.Model();
    this.params({
      page: 1,
      search: '',
      order: 'registered_on',
      direction: 'DESC',
      participant_group_ids: [],
      all_participants_selected: false
    });
  }
  /**
   * Set one or more query params or get all of them
   * @param {object} The key value pairs for query params to set
   * @return {object} All query params
   */
  ;

  _proto.params = function params(obj) {
    if (obj != null) {
      return this.queryParams.set(obj);
    } else {
      return this.queryParams.attributes;
    }
  }
  /**
   * Returns the path for the API endpoint
   * @return {string} The path for the endpoint
   */
  ;

  _proto.url = function url() {
    return '/api/participants';
  }
  /**
   * Converts a query param to a string
   * @param {string} Key of the query param
   * @return {string} Key and value of the query param converted to a string
   */
  ;

  _proto.toQueryString = function toQueryString(attr) {
    return "?" + attr + "=" + this.pluck(attr).join(',');
  }
  /**
   * Remove multiple participants
   * @param {string/collection} A collection of participants to remove or "all" for all participants
   */
  ;

  _proto.bulkRemove = function bulkRemove(participants, options) {
    if (options === void 0) {
      options = {};
    }

    if (participants != null) {
      if (participants === 'all') {
        return this.sync('delete', this).done(function () {
          return typeof options.success === 'function' ? options.success() : undefined;
        });
      } else {
        if (!participants.length) {
          return;
        }

        this.remove(participants);

        var attrs = _.invoke(participants, 'toJSON');

        return new Participants(attrs).bulkRemove(undefined, options);
      }
    } else {
      var url = URI('/api/participants').search({
        id: this.pluck('id').join(',')
      });
      return this.sync('delete', this, {
        url: url.toString()
      }).fail(function (xhr) {
        return typeof options.fail === 'function' ? options.fail(xhr) : undefined;
      }).done(function () {
        return typeof options.success === 'function' ? options.success() : undefined;
      });
    }
  }
  /** Set the checked attribute to true for all participants */
  ;

  _proto.checkAll = function checkAll() {
    return this.invoke('set', {
      checked: true
    });
  }
  /** Set the checked attribute to false for all participants */
  ;

  _proto.uncheckAll = function uncheckAll() {
    return this.invoke('set', {
      checked: false
    });
  }
  /**
   * Find participants in specified groups
   * @param {array} Array of group ids to search by
   */
  ;

  _proto.inParticipantGroups = function inParticipantGroups(groups) {
    this.queryParams.set({
      participant_group_ids: groups
    });
    return this.query();
  }
  /**
   * Find participants in a single group
   * @param {id} Group ID to search by
   */
  ;

  _proto.fetchByParticipantGroupID = function fetchByParticipantGroupID(participantGroupID) {
    this.queryParams.set({
      participant_group_ids: [participantGroupID]
    });
    return this.query();
  }
  /**
   * Fetch data with given options and reset collection with response data
   * @param {object} Options to search with (i.e. page, participant_group_ids)
   */
  ;

  _proto.query = function query(options) {
    if (options === void 0) {
      options = {};
    }

    if (!options.data) {
      options.data = {};
    }

    _.defaults(options.data, this.queryParams.attributes);

    options.reset = true;
    return this.fetch(options);
  }
  /** Find participants that are currently checked */
  ;

  _proto.checked = function checked() {
    return this.where({
      checked: true
    });
  }
  /**
   * Check if all participants are assigned to the specified group
   * @param {model} Participant group to check against
   * @return {boolean} Whether or not all participants are in the group
   */
  ;

  _proto.allAssignedTo = function allAssignedTo(group) {
    var output = true;
    this.each(function (participant) {
      if (!participant.groupIds().includes(group.id)) {
        output = false;
      }
    });
    return output;
  }
  /**
   * Check if any participants are assigned to the specified group
   * @param {model} Participant group to check against
   * @return {boolean} Whether or not one or more participants are in the group
   */
  ;

  _proto.someAssignedTo = function someAssignedTo(group) {
    var output = false;
    this.each(function (participant) {
      if (participant.groupIds().includes(group.id)) {
        output = true;
      }
    });
    return output;
  };

  _createClass(Participants, [{
    key: "model",
    get: function get() {
      return Participant;
    }
  }]);

  return Participants;
}(PaginatedCollection);

export { Participants as default };